import { createInstance } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { IS_TEST } from '../utils/config'

import de from './de.json'
import en from './en.json'
import fr from './fr.json'

export const instance18n = createInstance().use(LanguageDetector)

instance18n.init({
  resources: {
    en: {
      translation: en
    },
    de: {
      translation: de
    },
    fr: {
      translation: fr
    }
  },
  detection: {
    order: ['querystring', 'localStorage', 'navigator'],
    caches: ['localStorage'],
    lookupQuerystring: 'lng',
    lookupLocalStorage: 'locale'
  },
  lng: IS_TEST ? 'cimode' : 'de',
  fallbackLng: IS_TEST ? 'cimode' : 'en',
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: true
  }
})

export const getString = (name: string, params = {}) => {
  return instance18n.t(name, params)
}

export const changeLanguage = (lang: string) => {
  instance18n.changeLanguage(lang)
}
